import { supabase } from '../config/supabase';

export const testSupabaseConnection = async () => {
  try {
    console.log('Testing Supabase connection...');
    
    // Test basic connection with longer timeout (15 seconds)
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Connection timeout')), 15000)
    );
    
    const connectionPromise = supabase
      .from('service_categories')
      .select('count')
      .limit(1);
    
    const result = await Promise.race([connectionPromise, timeoutPromise]);
    
    // Type guard to check if result has error property
    if (result && typeof result === 'object' && 'error' in result && result.error) {
      console.warn('Supabase connection warning:', result.error);
      return false;
    }
    
    console.log('✅ Supabase connection successful!');
    return true;
  } catch (error) {
    console.warn('⚠️ Supabase connection failed (non-blocking):', error);
    // Don't block the app, just log the warning
    return false;
  }
};

export const initializeDatabase = async () => {
  try {
    console.log('Checking if database is initialized...');
    
    // Check if categories exist with longer timeout (10 seconds)
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Database check timeout')), 10000)
    );
    
    const checkPromise = supabase
      .from('service_categories')
      .select('*')
      .limit(1);
    
    const result = await Promise.race([checkPromise, timeoutPromise]);
    
    // Type guard to check if result has error property
    if (result && typeof result === 'object' && 'error' in result && result.error) {
      console.warn('Database check warning:', result.error);
      return false;
    }
    
    // Type guard to check if result has data property
    if (result && typeof result === 'object' && 'data' in result) {
      const categories = result.data;
      if (!categories || (Array.isArray(categories) && categories.length === 0)) {
        console.log('Database appears empty, you may need to run the SQL migrations');
        return false;
      }
    }
    
    console.log('✅ Database is initialized with data');
    return true;
  } catch (error) {
    console.warn('⚠️ Database initialization check failed (non-blocking):', error);
    // Don't block the app, just log the warning
    return false;
  }
};